const AUTH_REDIRECT_PATH_KEY = 'rapid-audit-auth-redirect-path';
function isSafeRedirectPath(path) {
    return Boolean(path &&
        path.startsWith('/') &&
        !path.startsWith('/login') &&
        !path.startsWith('/auth/callback'));
}
export function setAuthRedirectPath(path) {
    if (isSafeRedirectPath(path)) {
        sessionStorage.setItem(AUTH_REDIRECT_PATH_KEY, path);
    }
}
export function consumeAuthRedirectPath(defaultPath = '/audit/start') {
    const storedPath = sessionStorage.getItem(AUTH_REDIRECT_PATH_KEY);
    sessionStorage.removeItem(AUTH_REDIRECT_PATH_KEY);
    return isSafeRedirectPath(storedPath) ? storedPath : defaultPath;
}
export async function redirectToLogin(router, currentPath) {
    setAuthRedirectPath(currentPath);
    await router.push({
        path: '/login',
        query: {
            redirect: currentPath,
        },
    });
}
//# sourceMappingURL=auth-redirect.service.js.map